import { Priority, Subject, KnowledgeArea, StudyIntensity, StudyStrategy } from './types';

export const SUBJECT_TO_AREA = {
  [Subject.HISTORY]: KnowledgeArea.HUMAN_SCIENCES,
  [Subject.GEOGRAPHY]: KnowledgeArea.HUMAN_SCIENCES,
  [Subject.SOCIOLOGY]: KnowledgeArea.HUMAN_SCIENCES,
  [Subject.PHILOSOPHY]: KnowledgeArea.HUMAN_SCIENCES,
  
  [Subject.PHYSICS]: KnowledgeArea.NATURAL_SCIENCES,
  [Subject.CHEMISTRY]: KnowledgeArea.NATURAL_SCIENCES,
  [Subject.BIOLOGY]: KnowledgeArea.NATURAL_SCIENCES,
  
  [Subject.MATH]: KnowledgeArea.MATHEMATICS,
  
  [Subject.PORTUGUESE]: KnowledgeArea.LANGUAGES,
  [Subject.WRITING]: KnowledgeArea.LANGUAGES,
};

export const AREA_LABELS = {
  [KnowledgeArea.HUMAN_SCIENCES]: 'Ciências Humanas',
  [KnowledgeArea.NATURAL_SCIENCES]: 'Ciências da Natureza',
  [KnowledgeArea.MATHEMATICS]: 'Matemática',
  [KnowledgeArea.LANGUAGES]: 'Linguagens e Códigos',
};

export const INTENSITY_CONFIG = {
  [StudyIntensity.CAUTIOUS]: 6,
  [StudyIntensity.MODERATE]: 10,
  [StudyIntensity.INTENSE]: 16,
};

export const INTENSITY_LABELS = {
  [StudyIntensity.CAUTIOUS]: { label: 'Cauteloso', desc: 'Ritmo mais leve' },
  [StudyIntensity.MODERATE]: { label: 'Moderado', desc: 'Ritmo equilibrado' },
  [StudyIntensity.INTENSE]: { label: 'Intenso', desc: 'Ritmo puxado' },
};

export const STRATEGY_LABELS = {
  [StudyStrategy.COVER_ALL]: { 
    label: 'Ver Todo o Conteúdo', 
    desc: 'O cronograma será comprimido para caber tudo até a prova. Pode exceder sua intensidade diária.' 
  },
  [StudyStrategy.PRIORITIZE_HIGH]: { 
    label: 'Priorizar o Importante', 
    desc: 'Foca no que mais cai. Se o tempo for curto, conteúdos de baixa prioridade serão cortados.' 
  },
};

export const MATH_SYLLABUS = [
  // --- Matemática Básica ---
  {
    subject: Subject.MATH,
    categoryName: "Matemática Básica",
    priority: Priority.HIGH,
    topics: [
      { id: "mb-h-1", name: "Porcentagem", completed: false },
      { id: "mb-h-2", name: "Razões, Proporções e Regra de Três", completed: false },
      { id: "mb-h-3", name: "Regra de Três", completed: false },
      { id: "mb-h-4", name: "O Problema das Torneiras", completed: false },
    ]
  },
  {
    subject: Subject.MATH,
    categoryName: "Matemática Básica",
    priority: Priority.MEDIUM,
    topics: [
      { id: "mb-m-1", name: "Expressões Algébricas", completed: false },
      { id: "mb-m-2", name: "Regra de Sinais", completed: false },
      { id: "mb-m-3", name: "Potenciação", completed: false },
      { id: "mb-m-4", name: "Radiciação", completed: false },
      { id: "mb-m-5", name: "Frações e Operações com Frações", completed: false },
      { id: "mb-m-6", name: "Divisão de Frações", completed: false },
      { id: "mb-m-7", name: "Produtos Notáveis", completed: false },
      { id: "mb-m-8", name: "Fatoração de Expressões Algébricas", completed: false },
    ]
  },
  {
    subject: Subject.MATH,
    categoryName: "Matemática Básica",
    priority: Priority.LOW,
    topics: [
      { id: "mb-l-1", name: "Divisão de Números Naturais", completed: false },
      { id: "mb-l-2", name: "Multiplicação", completed: false },
      { id: "mb-l-3", name: "Expoente não Inteiro", completed: false },
      { id: "mb-l-4", name: "Relação entre Raiz Quadrada e Potenciação", completed: false },
      { id: "mb-l-5", name: "Generalização de Raiz n-ésima e Potenciação", completed: false },
      { id: "mb-l-6", name: "Potenciação e Distributividade", completed: false },
      { id: "mb-l-7", name: "Números Primos", completed: false },
      { id: "mb-l-8", name: "Critérios de Divisibilidade", completed: false },
      { id: "mb-l-9", name: "Fatoração de Números Inteiros", completed: false },
      { id: "mb-l-10", name: "Mínimo Múltiplo Comum (MMC)", completed: false },
      { id: "mb-l-11", name: "Máximo Divisor Comum (MDC)", completed: false },
      { id: "mb-l-12", name: "Revisitando MMC e MDC", completed: false },
      { id: "mb-l-13", name: "Soma e Diferença de Cubos", completed: false },
      { id: "mb-l-14", name: "Agrupamento de Expressões Algébricas", completed: false },
    ]
  },

  // --- Conjuntos e Funções ---
  {
    subject: Subject.MATH,
    categoryName: "Conjuntos e Funções",
    priority: Priority.HIGH,
    topics: [
      { id: "cf-h-1", name: "Plano Cartesiano", completed: false },
      { id: "cf-h-2", name: "Introdução às Funções", completed: false },
      { id: "cf-h-3", name: "Domínio, Contradomínio e Imagem", completed: false },
      { id: "cf-h-4", name: "Introdução à Função", completed: false },
      { id: "cf-h-5", name: "Função Afim (1º Grau)", completed: false },
      { id: "cf-h-6", name: "Função Quadrática (2º Grau)", completed: false },
      { id: "cf-h-7", name: "Função Exponencial", completed: false },
      { id: "cf-h-8", name: "Logaritmo e Função Logarítmica", completed: false },
    ]
  },
  {
    subject: Subject.MATH,
    categoryName: "Conjuntos e Funções",
    priority: Priority.MEDIUM,
    topics: [
      { id: "cf-m-1", name: "Conjuntos Numéricos", completed: false },
      { id: "cf-m-2", name: "Função Modular", completed: false },
    ]
  },
  {
    subject: Subject.MATH,
    categoryName: "Conjuntos e Funções",
    priority: Priority.LOW,
    topics: [
      { id: "cf-l-1", name: "Operações entre Conjuntos", completed: false },
      { id: "cf-l-2", name: "Funções Injetoras, Sobrejetoras e Bijetoras", completed: false },
      { id: "cf-l-3", name: "Composição e Inversão de Funções", completed: false },
    ]
  },

  // --- Geometria Plana ---
  {
    subject: Subject.MATH,
    categoryName: "Geometria Plana",
    priority: Priority.HIGH,
    topics: [
      { id: "gp-h-1", name: "Áreas de Figuras Planas", completed: false },
      { id: "gp-h-2", name: "Relações Métricas e Teorema de Pitágoras", completed: false },
    ]
  },
  {
    subject: Subject.MATH,
    categoryName: "Geometria Plana",
    priority: Priority.MEDIUM,
    topics: [
      { id: "gp-m-1", name: "Conceitos Básicos e Ângulos", completed: false },
      { id: "gp-m-2", name: "Triângulos e Pontos Notáveis", completed: false },
      { id: "gp-m-3", name: "Quadriláteros", completed: false },
      { id: "gp-m-4", name: "Circunferência e Círculo", completed: false },
      { id: "gp-m-5", name: "Polígonos", completed: false },
      { id: "gp-m-6", name: "Semelhança de Triângulos e Teorema de Tales", completed: false },
    ]
  },

  // --- Estatística ---
  {
    subject: Subject.MATH,
    categoryName: "Estatística",
    priority: Priority.HIGH,
    topics: [
      { id: "est-h-1", name: "Conceitos Básicos", completed: false },
      { id: "est-h-2", name: "Medidas de Dispersão", completed: false },
    ]
  },

  // --- Progressões ---
  {
    subject: Subject.MATH,
    categoryName: "Progressões",
    priority: Priority.MEDIUM,
    topics: [
      { id: "prog-m-1", name: "Progressão Aritmética (PA)", completed: false },
      { id: "prog-m-2", name: "Progressão Geométrica (PG)", completed: false },
    ]
  },

  // --- Matrizes e Sistemas Lineares ---
  {
    subject: Subject.MATH,
    categoryName: "Matrizes e Sistemas Lineares",
    priority: Priority.LOW,
    topics: [
      { id: "ms-l-1", name: "Matrizes e Operações", completed: false },
      { id: "ms-l-2", name: "Escalonamento", completed: false },
      { id: "ms-l-3", name: "Interpretação Geométrica de Sistemas", completed: false },
    ]
  },

  // --- Geometria Analítica ---
  {
    subject: Subject.MATH,
    categoryName: "Geometria Analítica",
    priority: Priority.LOW,
    topics: [
      { id: "ga-l-1", name: "Estudo do Ponto", completed: false },
      { id: "ga-l-2", name: "Estudo da Reta", completed: false },
      { id: "ga-l-3", name: "Estudo da Circunferência", completed: false },
      { id: "ga-l-4", name: "Cônicas (Elipse, Parábola, Hipérbole)", completed: false },
    ]
  },

  // --- Trigonometria ---
  {
    subject: Subject.MATH,
    categoryName: "Trigonometria",
    priority: Priority.MEDIUM,
    topics: [
      { id: "trig-m-1", name: "Trigonometria no Triângulo Retângulo", completed: false },
      { id: "trig-m-2", name: "Funções Trigonométricas", completed: false },
    ]
  },
  {
    subject: Subject.MATH,
    categoryName: "Trigonometria",
    priority: Priority.LOW,
    topics: [
      { id: "trig-l-1", name: "Equações e Inequações Trigonométricas", completed: false },
      { id: "trig-l-2", name: "Leis dos Senos e Cossenos", completed: false },
    ]
  },

  // --- Binômio de Newton, Análise Combinatória e Probabilidade ---
  {
    subject: Subject.MATH,
    categoryName: "Binômio de Newton, Análise Combinatória e Probabilidade",
    priority: Priority.HIGH,
    topics: [
      { id: "bc-h-1", name: "Probabilidade e Estatística", completed: false },
    ]
  },
  {
    subject: Subject.MATH,
    categoryName: "Binômio de Newton, Análise Combinatória e Probabilidade",
    priority: Priority.MEDIUM,
    topics: [
      { id: "bc-m-1", name: "Fatorial e 0! = 1", completed: false },
      { id: "bc-m-2", name: "Princípio Fundamental da Contagem", completed: false },
      { id: "bc-m-3", name: "Análise Combinatória", completed: false },
    ]
  },
  {
    subject: Subject.MATH,
    categoryName: "Binômio de Newton, Análise Combinatória e Probabilidade",
    priority: Priority.LOW,
    topics: [
      { id: "bc-l-1", name: "Binômio de Newton", completed: false },
    ]
  },

  // --- Geometria Espacial ---
  {
    subject: Subject.MATH,
    categoryName: "Geometria Espacial",
    priority: Priority.HIGH,
    topics: [
      { id: "ge-h-1", name: "Prismas", completed: false },
      { id: "ge-h-2", name: "Cilindros", completed: false },
      { id: "ge-h-3", name: "Pirâmides e Cones", completed: false },
      { id: "ge-h-4", name: "Esferas", completed: false },
    ]
  },
  {
    subject: Subject.MATH,
    categoryName: "Geometria Espacial",
    priority: Priority.MEDIUM,
    topics: [
      { id: "ge-m-1", name: "Sólidos de Revolução", completed: false },
    ]
  },
  {
    subject: Subject.MATH,
    categoryName: "Geometria Espacial",
    priority: Priority.LOW,
    topics: [
      { id: "ge-l-1", name: "Conceitos Primitivos e Poliedros", completed: false },
      { id: "ge-l-2", name: "Troncos de Cone e Pirâmide", completed: false },
      { id: "ge-l-3", name: "Inscrição e Circunscrição de Sólidos", completed: false },
      { id: "ge-l-4", name: "Relação de Euler", completed: false },
      { id: "ge-l-5", name: "Soma dos Ângulos das Faces", completed: false },
      { id: "ge-l-6", name: "Poliedros de Platão", completed: false },
    ]
  },

  // --- Números Complexos ---
  {
    subject: Subject.MATH,
    categoryName: "Números Complexos",
    priority: Priority.LOW,
    topics: [
      { id: "nc-l-1", name: "Números Complexos", completed: false },
      { id: "nc-l-2", name: "Operações com Números Complexos", completed: false },
      { id: "nc-l-3", name: "Forma Trigonométrica de um Número Complexo", completed: false },
      { id: "nc-l-4", name: "Interpretação Vetorial de um Número Complexo", completed: false },
      { id: "nc-l-5", name: "Potenciação de Números Complexos", completed: false },
      { id: "nc-l-6", name: "Radiciação de Números Complexos", completed: false },
    ]
  },

  // --- Polinômios ---
  {
    subject: Subject.MATH,
    categoryName: "Polinômios",
    priority: Priority.LOW,
    topics: [
      { id: "pol-l-1", name: "Conceitos Básicos", completed: false },
      { id: "pol-l-2", name: "Operações com Polinômios", completed: false },
      { id: "pol-l-3", name: "Teorema do Resto", completed: false },
      { id: "pol-l-4", name: "Bhaskara vs Soma e Produto", completed: false },
      { id: "pol-l-5", name: "Relações de Girard (polinômios de grau maior que 2)", completed: false },
      { id: "pol-l-6", name: "Teoremas Fundamentais da Álgebra e da Decomposição", completed: false },
      { id: "pol-l-7", name: "Teorema das Raízes Racionais", completed: false },
      { id: "pol-l-8", name: "Equações Recíprocas", completed: false },
      { id: "pol-l-9", name: "Multiplicidade de Raízes", completed: false },
    ]
  },

  // --- Matemática Financeira ---
  {
    subject: Subject.MATH,
    categoryName: "Matemática Financeira",
    priority: Priority.HIGH,
    topics: [
      { id: "mf-h-1", name: "Conceitos Básicos", completed: false },
      { id: "mf-h-2", name: "Juros Simples vs Juros Compostos", completed: false },
    ]
  },
];

export const PORTUGUESE_SYLLABUS = [
  // --- Gramática ---
  {
    subject: Subject.PORTUGUESE,
    categoryName: "Gramática",
    priority: Priority.HIGH,
    topics: [
      { id: "pt-g-h-1", name: "Sintaxe 1", completed: false },
      { id: "pt-g-h-2", name: "Sintaxe 2", completed: false },
      { id: "pt-g-h-3", name: "Semântica", completed: false },
    ]
  },
  {
    subject: Subject.PORTUGUESE,
    categoryName: "Gramática",
    priority: Priority.MEDIUM,
    topics: [
      { id: "pt-g-m-1", name: "Morfologia (Classes de Palavras)", completed: false },
      { id: "pt-g-m-2", name: "Outros", completed: false },
    ]
  },
  {
    subject: Subject.PORTUGUESE,
    categoryName: "Gramática",
    priority: Priority.LOW,
    topics: [
      { id: "pt-g-l-1", name: "Fonética e Fonologia", completed: false },
      { id: "pt-g-l-2", name: "Ortografia", completed: false },
    ]
  },

  // --- Literatura ---
  {
    subject: Subject.PORTUGUESE,
    categoryName: "Literatura",
    priority: Priority.HIGH,
    topics: [
      { id: "pt-l-h-1", name: "Romantismo", completed: false },
      { id: "pt-l-h-2", name: "Realismo e Naturalismo", completed: false },
      { id: "pt-l-h-3", name: "Pré-Modernismo e Modernismo", completed: false },
      { id: "pt-l-h-4", name: "Literatura Contemporânea", completed: false },
    ]
  },
  {
    subject: Subject.PORTUGUESE,
    categoryName: "Literatura",
    priority: Priority.MEDIUM,
    topics: [
      { id: "pt-l-m-1", name: "Barroco", completed: false },
      { id: "pt-l-m-2", name: "Arcadismo", completed: false },
      { id: "pt-l-m-3", name: "Parnasianismo e Simbolismo", completed: false },
    ]
  },
  {
    subject: Subject.PORTUGUESE,
    categoryName: "Literatura",
    priority: Priority.LOW,
    topics: [
      { id: "pt-l-l-1", name: "Trovadorismo", completed: false },
      { id: "pt-l-l-2", name: "Humanismo e Classicismo", completed: false },
      { id: "pt-l-l-3", name: "Quinhentismo", completed: false },
      { id: "pt-l-l-4", name: "Concretismo e Pós-moderno", completed: false },
    ]
  },
];

export const PHYSICS_SYLLABUS = [
  // --- Cinemática ---
  {
    subject: Subject.PHYSICS,
    categoryName: "Cinemática",
    priority: Priority.HIGH,
    topics: [
      { id: "fis-cin-h-1", name: "Conceitos Iniciais e Velocidade", completed: false },
      { id: "fis-cin-h-2", name: "Movimento Uniforme (MU)", completed: false },
      { id: "fis-cin-h-3", name: "Movimento Uniformemente Variado (MUV)", completed: false },
      { id: "fis-cin-h-4", name: "Lançamento Horizontal e Oblíquo", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Cinemática",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fis-cin-m-1", name: "Queda Livre e Lançamentos Verticais", completed: false },
      { id: "fis-cin-m-2", name: "Movimento Circular", completed: false },
    ]
  },

  // --- Dinâmica ---
  {
    subject: Subject.PHYSICS,
    categoryName: "Dinâmica",
    priority: Priority.HIGH,
    topics: [
      { id: "fis-din-h-1", name: "Leis de Newton", completed: false },
      { id: "fis-din-h-2", name: "Forças (Atrito, Elástica, Centrípeta)", completed: false },
      { id: "fis-din-h-3", name: "Plano Inclinado", completed: false },
      { id: "fis-din-h-4", name: "Trabalho e Potência", completed: false },
      { id: "fis-din-h-5", name: "Energia (Cinética, Potencial, Mecânica)", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Dinâmica",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fis-din-m-1", name: "Conceitos Iniciais", completed: false },
      { id: "fis-din-m-2", name: "Polias, Elevadores e Torques", completed: false },
      { id: "fis-din-m-3", name: "Sistemas Conservativos e Dissipativos", completed: false },
      { id: "fis-din-m-4", name: "Impulso e Quantidade de Movimento", completed: false },
      { id: "fis-din-m-5", name: "Colisões", completed: false },
    ]
  },

  // --- Hidrostática ---
  {
    subject: Subject.PHYSICS,
    categoryName: "Hidrostática",
    priority: Priority.HIGH,
    topics: [
      { id: "fis-hid-h-1", name: "Hidrostática (Pressão, Teorema de Stevin, Pascal, Arquimedes)", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Hidrostática",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fis-hid-m-1", name: "Conceitos Iniciais", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Hidrostática",
    priority: Priority.LOW,
    topics: [
      { id: "fis-hid-l-1", name: "Hidrodinâmica", completed: false },
    ]
  },

  // --- Gravitação ---
  {
    subject: Subject.PHYSICS,
    categoryName: "Gravitação",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fis-grav-m-1", name: "Lei da Gravitação Universal", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Gravitação",
    priority: Priority.LOW,
    topics: [
      { id: "fis-grav-l-1", name: "Leis de Kepler", completed: false },
    ]
  },

  // --- Óptica ---
  {
    subject: Subject.PHYSICS,
    categoryName: "Óptica",
    priority: Priority.HIGH,
    topics: [
      { id: "fis-opt-h-1", name: "Espelhos Planos e Esféricos", completed: false },
      { id: "fis-opt-h-2", name: "Reflexão e Refração", completed: false },
      { id: "fis-opt-h-3", name: "Lentes Esféricas", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Óptica",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fis-opt-m-1", name: "Princípios da Óptica Geométrica", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Óptica",
    priority: Priority.LOW,
    topics: [
      { id: "fis-opt-l-1", name: "Dioptro Plano", completed: false },
      { id: "fis-opt-l-2", name: "Prisma", completed: false },
      { id: "fis-opt-l-3", name: "Instrumentos Ópticos", completed: false },
      { id: "fis-opt-l-4", name: "Olho Humano", completed: false },
    ]
  },

  // --- Ondulatória ---
  {
    subject: Subject.PHYSICS,
    categoryName: "Ondulatória",
    priority: Priority.HIGH,
    topics: [
      { id: "fis-ond-h-1", name: "Movimento Harmônico Simples (MHS)", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Ondulatória",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fis-ond-m-1", name: "Conceitos Iniciais", completed: false },
      { id: "fis-ond-m-2", name: "Ressonância e Interferência", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Ondulatória",
    priority: Priority.LOW,
    topics: [
      { id: "fis-ond-l-1", name: "Equação de Taylor", completed: false },
      { id: "fis-ond-l-2", name: "Difração e Polarização", completed: false },
    ]
  },

  // --- Acústica ---
  {
    subject: Subject.PHYSICS,
    categoryName: "Acústica",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fis-acu-m-1", name: "Conceitos Iniciais", completed: false },
      { id: "fis-acu-m-2", name: "Cordas e Tubos", completed: false },
      { id: "fis-acu-m-3", name: "Efeito Doppler", completed: false },
    ]
  },

  // --- Termometria ---
  {
    subject: Subject.PHYSICS,
    categoryName: "Termometria",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fis-term-m-1", name: "Conceitos Iniciais e Escalas de Temperatura", completed: false },
    ]
  },

  // --- Calorimetria ---
  {
    subject: Subject.PHYSICS,
    categoryName: "Calorimetria",
    priority: Priority.HIGH,
    topics: [
      { id: "fis-cal-h-1", name: "Calor Específico e Trocas de Calor", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Calorimetria",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fis-cal-m-1", name: "Dilatação Térmica", completed: false },
      { id: "fis-cal-m-2", name: "Calor Latente", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Calorimetria",
    priority: Priority.LOW,
    topics: [
      { id: "fis-cal-l-1", name: "Diagrama de Fase", completed: false },
      { id: "fis-cal-l-2", name: "Propagação de Calor", completed: false },
    ]
  },

  // --- Termodinâmica ---
  {
    subject: Subject.PHYSICS,
    categoryName: "Termodinâmica",
    priority: Priority.HIGH,
    topics: [
      { id: "fis-td-h-1", name: "Primeira Lei da Termodinâmica", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Termodinâmica",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fis-td-m-1", name: "Transformações Gasosas", completed: false },
      { id: "fis-td-m-2", name: "Trabalho de um Gás", completed: false },
      { id: "fis-td-m-3", name: "Energia Interna de um Gás", completed: false },
      { id: "fis-td-m-4", name: "Máquinas Térmicas", completed: false },
      { id: "fis-td-m-5", name: "Segunda Lei da Termodinâmica", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Termodinâmica",
    priority: Priority.LOW,
    topics: [
      { id: "fis-td-l-1", name: "Equação de Clapeyron e Transformação Adiabática", completed: false },
      { id: "fis-td-l-2", name: "Ciclo de Carnot", completed: false },
    ]
  },

  // --- Eletrostática ---
  {
    subject: Subject.PHYSICS,
    categoryName: "Eletrostática",
    priority: Priority.HIGH,
    topics: [
      { id: "fis-ele-h-1", name: "Processos de Eletrização", completed: false },
      { id: "fis-ele-h-2", name: "Campos Elétricos", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Eletrostática",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fis-ele-m-1", name: "Carga Elétrica", completed: false },
      { id: "fis-ele-m-2", name: "Força Elétrica", completed: false },
    ]
  },

  // --- Eletrodinâmica ---
  {
    subject: Subject.PHYSICS,
    categoryName: "Eletrodinâmica",
    priority: Priority.HIGH,
    topics: [
      { id: "fis-eld-h-1", name: "Corrente Elétrica", completed: false },
      { id: "fis-eld-h-2", name: "Tensão e Potência Elétrica", completed: false },
      { id: "fis-eld-h-3", name: "Primeira e Segunda Leis de Ohm", completed: false },
      { id: "fis-eld-h-4", name: "Associação de Resistores", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Eletrodinâmica",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fis-eld-m-1", name: "Geradores", completed: false },
      { id: "fis-eld-m-2", name: "Receptores", completed: false },
      { id: "fis-eld-m-3", name: "Circuito", completed: false },
      { id: "fis-eld-m-4", name: "Amperímetro e Voltímetro", completed: false },
      { id: "fis-eld-m-5", name: "Leis de Kirchoff", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Eletrodinâmica",
    priority: Priority.LOW,
    topics: [
      { id: "fis-eld-l-1", name: "Capacitores", completed: false },
    ]
  },

  // --- Eletromagnetismo ---
  {
    subject: Subject.PHYSICS,
    categoryName: "Eletromagnetismo",
    priority: Priority.HIGH,
    topics: [
      { id: "fis-mag-h-1", name: "Fluxo Magnético, Lei de Lenz e Lei de Faraday", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Eletromagnetismo",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fis-mag-m-1", name: "Ímãs", completed: false },
      { id: "fis-mag-m-2", name: "Força Magnética (força sobre carga e trajetórias)", completed: false },
      { id: "fis-mag-m-3", name: "Campo Magnético", completed: false },
      { id: "fis-mag-m-4", name: "Transformadores", completed: false },
    ]
  },

  // --- Moderna ---
  {
    subject: Subject.PHYSICS,
    categoryName: "Física Moderna",
    priority: Priority.HIGH,
    topics: [
      { id: "fis-mod-h-1", name: "Efeito Fotoelétrico", completed: false },
    ]
  },
  {
    subject: Subject.PHYSICS,
    categoryName: "Física Moderna",
    priority: Priority.LOW,
    topics: [
      { id: "fis-mod-l-1", name: "Relatividade", completed: false },
      { id: "fis-mod-l-2", name: "Radiação de Corpo Negro", completed: false },
      { id: "fis-mod-l-3", name: "Átomo de Bohr", completed: false },
    ]
  },
];

export const CHEMISTRY_SYLLABUS = [
  // --- Química Geral ---
  {
    subject: Subject.CHEMISTRY,
    categoryName: "Química Geral",
    priority: Priority.HIGH,
    topics: [
      { id: "qui-ger-h-1", name: "Tabela Periódica e Propriedades", completed: false },
      { id: "qui-ger-h-2", name: "Matéria, Substâncias, Misturas e Separação", completed: false },
      { id: "qui-ger-h-3", name: "Ligações Químicas", completed: false },
    ]
  },
  {
    subject: Subject.CHEMISTRY,
    categoryName: "Química Geral",
    priority: Priority.MEDIUM,
    topics: [
      { id: "qui-ger-m-1", name: "Modelos Atômicos e Leis Ponderais", completed: false },
      { id: "qui-ger-m-2", name: "Forças Intermoleculares", completed: false },
      { id: "qui-ger-m-3", name: "Geometria Molecular e Polaridade", completed: false },
    ]
  },
  {
    subject: Subject.CHEMISTRY,
    categoryName: "Química Geral",
    priority: Priority.LOW,
    topics: [
      { id: "qui-ger-l-1", name: "Estados Físicos e Mudança de Estado", completed: false },
    ]
  },

  // --- Química Orgânica ---
  {
    subject: Subject.CHEMISTRY,
    categoryName: "Química Orgânica",
    priority: Priority.HIGH,
    topics: [
      { id: "qui-org-h-1", name: "Funções Orgânicas", completed: false },
      { id: "qui-org-h-2", name: "Polímeros, Petróleo e Biocombustíveis", completed: false },
      { id: "qui-org-h-3", name: "Bioquímica: aminoácidos, proteínas e carboidratos", completed: false },
    ]
  },
  {
    subject: Subject.CHEMISTRY,
    categoryName: "Química Orgânica",
    priority: Priority.MEDIUM,
    topics: [
      { id: "qui-org-m-1", name: "Introdução e Cadeias Carbônicas", completed: false },
      { id: "qui-org-m-2", name: "Isomeria Plana e Espacial", completed: false },
      { id: "qui-org-m-3", name: "Reações Orgânicas", completed: false },
    ]
  },
  {
    subject: Subject.CHEMISTRY,
    categoryName: "Química Orgânica",
    priority: Priority.LOW,
    topics: [
      { id: "qui-org-l-1", name: "Ácidos e Bases em Compostos Orgânicos", completed: false },
    ]
  },

  // --- Química Inorgânica ---
  {
    subject: Subject.CHEMISTRY,
    categoryName: "Química Inorgânica",
    priority: Priority.HIGH,
    topics: [
      { id: "qui-ino-h-1", name: "Cálculo Estequiométrico", completed: false },
      { id: "qui-ino-h-2", name: "Funções Inorgânicas (Ácidos, Bases, Sais, Óxidos)", completed: false },
      { id: "qui-ino-h-3", name: "Estudo das Soluções", completed: false },
      { id: "qui-ino-h-4", name: "Oxirredução e Número de Oxidação (NOx)", completed: false },
      { id: "qui-ino-h-5", name: "Eletroquímica: Pilhas e Eletrólises", completed: false },
    ]
  },
  {
    subject: Subject.CHEMISTRY,
    categoryName: "Química Inorgânica",
    priority: Priority.MEDIUM,
    topics: [
      { id: "qui-ino-m-1", name: "Reações Inorgânicas", completed: false },
      { id: "qui-ino-m-2", name: "Propriedades Coligativas", completed: false },
    ]
  },
  {
    subject: Subject.CHEMISTRY,
    categoryName: "Química Inorgânica",
    priority: Priority.LOW,
    topics: [
      { id: "qui-ino-l-1", name: "Radioatividade", completed: false },
    ]
  },

  // --- Físico-Química ---
  {
    subject: Subject.CHEMISTRY,
    categoryName: "Físico-Química",
    priority: Priority.HIGH,
    topics: [
      { id: "qui-fis-h-1", name: "Termoquímica", completed: false },
      { id: "qui-fis-h-2", name: "Equilíbrio Químico e pH", completed: false },
    ]
  },
  {
    subject: Subject.CHEMISTRY,
    categoryName: "Físico-Química",
    priority: Priority.MEDIUM,
    topics: [
      { id: "qui-fis-m-1", name: "Gases Ideais e Leis dos Gases", completed: false },
      { id: "qui-fis-m-2", name: "Cinética Química", completed: false },
    ]
  },
];

export const HISTORY_SYLLABUS = [
  // --- História do Brasil ---
  {
    subject: Subject.HISTORY,
    categoryName: "História do Brasil",
    priority: Priority.HIGH,
    topics: [
      { id: "his-br-h-1", name: "Brasil Colonial (1530-1822)", completed: false },
      { id: "his-br-h-2", name: "Brasil Império (1822-1889)", completed: false },
      { id: "his-br-h-3", name: "Primeira República (1890-1930)", completed: false },
      { id: "his-br-h-4", name: "Era Vargas (1930-1945)", completed: false },
      { id: "his-br-h-5", name: "Ditadura Militar (1964-1985)", completed: false },
      { id: "his-br-h-6", name: "Redemocratização até o séc. XXI", completed: false },
      { id: "his-br-h-7", name: "Temas diversos na História do Brasil", completed: false },
    ]
  },
  {
    subject: Subject.HISTORY,
    categoryName: "História do Brasil",
    priority: Priority.MEDIUM,
    topics: [
      { id: "his-br-m-1", name: "República Populista (1945-1964)", completed: false },
    ]
  },
  {
    subject: Subject.HISTORY,
    categoryName: "História do Brasil",
    priority: Priority.LOW,
    topics: [
      { id: "his-br-l-1", name: "Brasil Antes do Contato (Pré-1500)", completed: false },
      { id: "his-br-l-2", name: "Brasil Pré-Colonial (1500-1530)", completed: false },
    ]
  },

  // --- História Geral ---
  {
    subject: Subject.HISTORY,
    categoryName: "História Geral",
    priority: Priority.HIGH,
    topics: [
      { id: "his-ger-h-1", name: "Idade Moderna", completed: false },
      { id: "his-ger-h-2", name: "Idade Contemporânea", completed: false },
    ]
  },
  {
    subject: Subject.HISTORY,
    categoryName: "História Geral",
    priority: Priority.MEDIUM,
    topics: [
      { id: "his-ger-m-1", name: "Antiguidade Oriental e Africana", completed: false },
      { id: "his-ger-m-2", name: "Antiguidade Ocidental/Clássica", completed: false },
      { id: "his-ger-m-3", name: "Idade Média", completed: false },
    ]
  },
  {
    subject: Subject.HISTORY,
    categoryName: "História Geral",
    priority: Priority.LOW,
    topics: [
      { id: "his-ger-l-1", name: "Pré-História", completed: false },
    ]
  },
];

export const GEOGRAPHY_SYLLABUS = [
  // --- Cartografia e Geologia ---
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "Cartografia e Geologia",
    priority: Priority.HIGH,
    topics: [
      { id: "geo-cart-h-1", name: "Cartografia", completed: false },
      { id: "geo-cart-h-2", name: "Escala Geográfica", completed: false },
      { id: "geo-cart-h-3", name: "Relevo do Brasil", completed: false },
      { id: "geo-cart-h-4", name: "Recursos Minerais Brasileiros", completed: false },
    ]
  },
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "Cartografia e Geologia",
    priority: Priority.MEDIUM,
    topics: [
      { id: "geo-cart-m-1", name: "Aspectos Físico-Naturais e Estrutura Geológica", completed: false },
      { id: "geo-cart-m-2", name: "Estrutura Geológica do Brasil", completed: false },
      { id: "geo-cart-m-3", name: "Geomorfologia", completed: false },
      { id: "geo-cart-m-4", name: "Solos (Pedologia)", completed: false },
      { id: "geo-cart-m-5", name: "Recursos Minerais", completed: false },
    ]
  },
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "Cartografia e Geologia",
    priority: Priority.LOW,
    topics: [
      { id: "geo-cart-l-1", name: "Relevo de São Paulo", completed: false },
    ]
  },

  // --- Climatologia ---
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "Climatologia",
    priority: Priority.HIGH,
    topics: [
      { id: "geo-clim-h-1", name: "Movimentos da Terra", completed: false },
      { id: "geo-clim-h-2", name: "Clima: Elementos e Fatores", completed: false },
      { id: "geo-clim-h-3", name: "Climas", completed: false },
      { id: "geo-clim-h-4", name: "Climas do Brasil", completed: false },
      { id: "geo-clim-h-5", name: "Fenômenos Climáticos - El Niño e La Niña", completed: false },
    ]
  },
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "Climatologia",
    priority: Priority.MEDIUM,
    topics: [
      { id: "geo-clim-m-1", name: "Fusos Horários", completed: false },
      { id: "geo-clim-m-2", name: "Climatologia", completed: false },
      { id: "geo-clim-m-3", name: "A atmosfera e o clima", completed: false },
      { id: "geo-clim-m-4", name: "Climas do Mundo", completed: false },
    ]
  },
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "Climatologia",
    priority: Priority.LOW,
    topics: [
      { id: "geo-clim-l-1", name: "Circulação da atmosfera, furacões e tornados", completed: false },
    ]
  },

  // --- Hidrografia e Meio Ambiente ---
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "Hidrografia e Meio Ambiente",
    priority: Priority.HIGH,
    topics: [
      { id: "geo-hid-h-1", name: "Hidrografia e Bacias Hidrográficas", completed: false },
      { id: "geo-hid-h-2", name: "Rios e Bacias Brasileiras e Mundiais", completed: false },
      { id: "geo-hid-h-3", name: "Domínios Morfoclimáticos", completed: false },
      { id: "geo-hid-h-4", name: "Vegetações do Brasil", completed: false },
      { id: "geo-hid-h-5", name: "Mudanças Climáticas (Aquecimento, Ozônio)", completed: false },
      { id: "geo-hid-h-6", name: "Desmatamento no Brasil", completed: false },
      { id: "geo-hid-h-7", name: "Impactos Ambientais", completed: false },
    ]
  },
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "Hidrografia e Meio Ambiente",
    priority: Priority.MEDIUM,
    topics: [
      { id: "geo-hid-m-1", name: "Vegetações do Mundo", completed: false },
      { id: "geo-hid-m-2", name: "Hotspots Brasileiros", completed: false },
      { id: "geo-hid-m-3", name: "Conferências Mundiais para o Meio Ambiente", completed: false },
      { id: "geo-hid-m-4", name: "Seca Histórica na Amazônia", completed: false },
    ]
  },

  // --- Geografia do Brasil (Humana) ---
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "Geografia do Brasil (Humana)",
    priority: Priority.HIGH,
    topics: [
      { id: "geo-br-h-1", name: "Formação Territorial e Espaço Geográfico", completed: false },
      { id: "geo-br-h-2", name: "Regionalização Brasileira", completed: false },
      { id: "geo-br-h-3", name: "Geografia Agrária e Agricultura do Brasil", completed: false },
      { id: "geo-br-h-4", name: "Geografia Urbana", completed: false },
      { id: "geo-br-h-5", name: "Processo de Industrialização do Brasil", completed: false },
      { id: "geo-br-h-6", name: "Problemas Sociais e Ambientais Urbanos", completed: false },
    ]
  },
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "Geografia do Brasil (Humana)",
    priority: Priority.MEDIUM,
    topics: [
      { id: "geo-br-m-1", name: "Sistemas Agrícolas e Modos de Produção", completed: false },
      { id: "geo-br-m-2", name: "Agricultura do Brasil: Produções Regionais", completed: false },
    ]
  },

  // --- População e Demografia ---
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "População e Demografia",
    priority: Priority.HIGH,
    topics: [
      { id: "geo-pop-h-1", name: "População: Conceitos Gerais", completed: false },
      { id: "geo-pop-h-2", name: "Crescimento e Transição Demográfica", completed: false },
      { id: "geo-pop-h-3", name: "A Dinâmica Populacional Brasileira", completed: false },
      { id: "geo-pop-h-4", name: "Movimentos Migratórios e Migrações no Brasil", completed: false },
      { id: "geo-pop-h-5", name: "Refugiados e Migração Global", completed: false },
    ]
  },
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "População e Demografia",
    priority: Priority.MEDIUM,
    topics: [
      { id: "geo-pop-m-1", name: "Teorias Demográficas", completed: false },
      { id: "geo-pop-m-2", name: "As Mudanças na População Global", completed: false },
      { id: "geo-pop-m-3", name: "Migrações Internas e em Países Desenvolvidos", completed: false },
    ]
  },

  // --- Geografia e Mundo Contemporâneo ---
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "Geopolítica e Economia Global",
    priority: Priority.HIGH,
    topics: [
      { id: "geo-eco-h-1", name: "Globalização", completed: false },
      { id: "geo-eco-h-2", name: "Fases do Capitalismo e a DIT", completed: false },
      { id: "geo-eco-h-3", name: "Matriz Energética Mundial e Transição Energética", completed: false },
      { id: "geo-eco-h-4", name: "Matriz Energética Brasileira", completed: false },
      { id: "geo-eco-h-5", name: "Geopolítica Internacional e Nova Ordem Mundial", completed: false },
      { id: "geo-eco-h-6", name: "Blocos Econômicos: UE, BRICS, MERCOSUL", completed: false },
      { id: "geo-eco-h-7", name: "As Revoluções Industriais", completed: false },
    ]
  },
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "Geopolítica e Economia Global",
    priority: Priority.MEDIUM,
    topics: [
      { id: "geo-eco-m-1", name: "Taylorismo e Fordismo", completed: false },
      { id: "geo-eco-m-2", name: "Velha Ordem Mundial", completed: false },
      { id: "geo-eco-m-3", name: "Formação da União Europeia", completed: false },
      { id: "geo-eco-m-4", name: "NAFTA", completed: false },
    ]
  },
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "Geopolítica e Economia Global",
    priority: Priority.LOW,
    topics: [
      { id: "geo-eco-l-1", name: "França e os BRICS", completed: false },
    ]
  },

  // --- Geografia Regional e Conflitos ---
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "Geografia Regional e Conflitos",
    priority: Priority.HIGH,
    topics: [
      { id: "geo-reg-h-1", name: "América Latina", completed: false },
      { id: "geo-reg-h-2", name: "Geografia da África e Aspectos Econômicos", completed: false },
      { id: "geo-reg-h-3", name: "Continente Asiático e Oriente Médio", completed: false },
      { id: "geo-reg-h-4", name: "Questão Palestina e Primavera Árabe", completed: false },
      { id: "geo-reg-h-5", name: "Guerra entre Rússia e Ucrânia", completed: false },
      { id: "geo-reg-h-6", name: "China e Taiwan", completed: false },
    ]
  },
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "Geografia Regional e Conflitos",
    priority: Priority.MEDIUM,
    topics: [
      { id: "geo-reg-m-1", name: "Continente Americano e América Anglo-Saxônica", completed: false },
      { id: "geo-reg-m-2", name: "Continente Europeu", completed: false },
      { id: "geo-reg-m-3", name: "África: Aspectos Físicos e Influência Chinesa", completed: false },
      { id: "geo-reg-m-4", name: "Monções e Desastres na Ásia", completed: false },
      { id: "geo-reg-m-5", name: "Conflito Índia x Paquistão (Caxemira)", completed: false },
      { id: "geo-reg-m-6", name: "Sudão e Talibãs", completed: false },
      { id: "geo-reg-m-7", name: "Geografia da Rússia, Índia e Japão", completed: false },
      { id: "geo-reg-m-8", name: "Tigres Asiáticos", completed: false },
    ]
  },
  {
    subject: Subject.GEOGRAPHY,
    categoryName: "Geografia Regional e Conflitos",
    priority: Priority.LOW,
    topics: [
      { id: "geo-reg-l-1", name: "A Guerra Entre EUA e Canadá", completed: false },
      { id: "geo-reg-l-2", name: "Acordo Trilateral", completed: false },
    ]
  },
];

export const BIOLOGY_SYLLABUS = [
  // --- Bioquímica e Citologia ---
  {
    subject: Subject.BIOLOGY,
    categoryName: "Bioquímica e Citologia",
    priority: Priority.HIGH,
    topics: [
      { id: "bio-cel-h-1", name: "Propriedades da água", completed: false },
      { id: "bio-cel-h-2", name: "Estrutura do DNA", completed: false },
      { id: "bio-cel-h-3", name: "Teoria da Endossimbiose", completed: false },
      { id: "bio-cel-h-4", name: "Diferenças de Procariontes e Eucariontes", completed: false },
      { id: "bio-cel-h-5", name: "Célula Animal e Célula Vegetal", completed: false },
      { id: "bio-cel-h-6", name: "Membrana Citoplasmática", completed: false },
      { id: "bio-cel-h-7", name: "Organelas Celulares", completed: false },
      { id: "bio-cel-h-8", name: "Mitose e Meiose", completed: false },
      { id: "bio-cel-h-9", name: "Respiração Celular e Fotossíntese", completed: false },
    ]
  },
  {
    subject: Subject.BIOLOGY,
    categoryName: "Bioquímica e Citologia",
    priority: Priority.MEDIUM,
    topics: [
      { id: "bio-cel-m-1", name: "Introdução à bioquímica", completed: false },
      { id: "bio-cel-m-2", name: "Sais minerais, Carboidratos, Lipídios, Proteínas", completed: false },
      { id: "bio-cel-m-3", name: "Ácidos nucleicos e Replicação", completed: false },
      { id: "bio-cel-m-4", name: "Abiogênese X Biogênese", completed: false },
      { id: "bio-cel-m-5", name: "Núcleo", completed: false },
      { id: "bio-cel-m-6", name: "Gametogênese", completed: false },
      { id: "bio-cel-m-7", name: "Fermentação", completed: false },
    ]
  },
  {
    subject: Subject.BIOLOGY,
    categoryName: "Bioquímica e Citologia",
    priority: Priority.LOW,
    topics: [
      { id: "bio-cel-l-1", name: "Transcrição, Splicing e Tradução", completed: false },
      { id: "bio-cel-l-2", name: "Hipóteses e experimentos de origem da vida", completed: false },
      { id: "bio-cel-l-3", name: "Hipótese Autotrófica e Heterotrófica", completed: false },
      { id: "bio-cel-l-4", name: "Intérfase", completed: false },
      { id: "bio-cel-l-5", name: "Quimiossíntese", completed: false },
    ]
  },

  // --- Genética e Evolução ---
  {
    subject: Subject.BIOLOGY,
    categoryName: "Genética e Evolução",
    priority: Priority.HIGH,
    topics: [
      { id: "bio-gen-h-1", name: "Introdução à genética e 1ª Lei de Mendel", completed: false },
      { id: "bio-gen-h-2", name: "Heredogramas", completed: false },
      { id: "bio-gen-h-3", name: "Grupos Sanguíneos (ABO e Rh)", completed: false },
      { id: "bio-gen-h-4", name: "Herança sexual", completed: false },
      { id: "bio-gen-h-5", name: "Equilíbrio de Hardy-Weinberg", completed: false },
      { id: "bio-gen-h-6", name: "Darwin e Teoria Sintética da Evolução", completed: false },
      { id: "bio-gen-h-7", name: "Darwin vs Lamarck", completed: false },
      { id: "bio-gen-h-8", name: "Evidências da Evolução", completed: false },
    ]
  },
  {
    subject: Subject.BIOLOGY,
    categoryName: "Genética e Evolução",
    priority: Priority.MEDIUM,
    topics: [
      { id: "bio-gen-m-1", name: "Alelos letais e Polialeia", completed: false },
      { id: "bio-gen-m-2", name: "Codominância e dominância incompleta", completed: false },
      { id: "bio-gen-m-3", name: "Epistasia e Interações gênicas", completed: false },
      { id: "bio-gen-m-4", name: "Linkage e Crossing Over", completed: false },
      { id: "bio-gen-m-5", name: "Mutações gênicas e cromossômicas", completed: false },
      { id: "bio-gen-m-6", name: "Lamarckismo", completed: false },
      { id: "bio-gen-m-7", name: "Especiação, Camuflagem e mimetismo", completed: false },
    ]
  },

  // --- Ecologia ---
  {
    subject: Subject.BIOLOGY,
    categoryName: "Ecologia",
    priority: Priority.HIGH,
    topics: [
      { id: "bio-eco-h-1", name: "Introdução à Ecologia e Níveis de Organização", completed: false },
      { id: "bio-eco-h-2", name: "Dinâmica Populacional", completed: false },
      { id: "bio-eco-h-3", name: "Cadeias, Teias e Pirâmides Ecológicas", completed: false },
      { id: "bio-eco-h-4", name: "Relações Ecológicas", completed: false },
      { id: "bio-eco-h-5", name: "Ciclos Biogeoquímicos (Água, Carbono, Nitrogênio)", completed: false },
      { id: "bio-eco-h-6", name: "Impactos Ambientais (Estufa, Ozônio, Bioacumulação)", completed: false },
      { id: "bio-eco-h-7", name: "Sustentabilidade", completed: false },
      { id: "bio-eco-h-8", name: "Biomas Brasileiros e do Mundo", completed: false },
    ]
  },
  {
    subject: Subject.BIOLOGY,
    categoryName: "Ecologia",
    priority: Priority.MEDIUM,
    topics: [
      { id: "bio-eco-m-1", name: "Sucessão Ecológica", completed: false },
      { id: "bio-eco-m-2", name: "Ciclos do Oxigênio e Fósforo", completed: false },
      { id: "bio-eco-m-3", name: "Eutrofização", completed: false },
    ]
  },

  // --- Diversidade da Vida: Micro e Fungos ---
  {
    subject: Subject.BIOLOGY,
    categoryName: "Diversidade da Vida: Micro e Fungos",
    priority: Priority.HIGH,
    topics: [
      { id: "bio-mic-h-1", name: "Classificação: 5 Reinos e 3 Domínios", completed: false },
      { id: "bio-mic-h-2", name: "Filogenia e Cladogramas", completed: false },
      { id: "bio-mic-h-3", name: "Vírus e Ciclos Virais", completed: false },
      { id: "bio-mic-h-4", name: "Bacterioses (Doenças)", completed: false },
      { id: "bio-mic-h-5", name: "Protozooses (Chagas, Leishmaniose, Malária)", completed: false },
      { id: "bio-mic-h-6", name: "Importância dos Fungos", completed: false },
    ]
  },
  {
    subject: Subject.BIOLOGY,
    categoryName: "Diversidade da Vida: Micro e Fungos",
    priority: Priority.MEDIUM,
    topics: [
      { id: "bio-mic-m-1", name: "Mono, Para e Polifiletismo", completed: false },
      { id: "bio-mic-m-2", name: "Reino Monera: Reprodução e Metabolismo", completed: false },
      { id: "bio-mic-m-3", name: "Cianobactérias e Arqueas", completed: false },
      { id: "bio-mic-m-4", name: "Algas Uni e Pluricelulares", completed: false },
      { id: "bio-mic-m-5", name: "Amebíase", completed: false },
      { id: "bio-mic-m-6", name: "Fungos: Características gerais", completed: false },
    ]
  },
  {
    subject: Subject.BIOLOGY,
    categoryName: "Diversidade da Vida: Micro e Fungos",
    priority: Priority.LOW,
    topics: [
      { id: "bio-mic-l-1", name: "Regras de nomenclatura", completed: false },
      { id: "bio-mic-l-2", name: "Reprodução de Algas", completed: false },
      { id: "bio-mic-l-3", name: "Classificação e Reprodução dos Fungos", completed: false },
    ]
  },

  // --- Botânica ---
  {
    subject: Subject.BIOLOGY,
    categoryName: "Botânica",
    priority: Priority.HIGH,
    topics: [
      { id: "bio-bot-h-1", name: "Reino Vegetal e Angiospermas", completed: false },
    ]
  },
  {
    subject: Subject.BIOLOGY,
    categoryName: "Botânica",
    priority: Priority.MEDIUM,
    topics: [
      { id: "bio-bot-m-1", name: "Briófitas, Pteridófitas e Gimnospermas", completed: false },
      { id: "bio-bot-m-2", name: "Monocotiledôneas e Dicotiledôneas", completed: false },
      { id: "bio-bot-m-3", name: "Tecidos Vegetais", completed: false },
      { id: "bio-bot-m-4", name: "Condução de Seiva", completed: false },
      { id: "bio-bot-m-5", name: "Hormônios Vegetais e Fotoperiodismo", completed: false },
    ]
  },
  {
    subject: Subject.BIOLOGY,
    categoryName: "Botânica",
    priority: Priority.LOW,
    topics: [
      { id: "bio-bot-l-1", name: "Morfologia Vegetal (Raiz, Caule, Folha)", completed: false },
      { id: "bio-bot-l-2", name: "Movimentos Vegetais", completed: false },
      { id: "bio-bot-l-3", name: "Tecidos de Revestimento e Sustentação", completed: false },
    ]
  },

  // --- Zoologia e Embriologia ---
  {
    subject: Subject.BIOLOGY,
    categoryName: "Zoologia e Embriologia",
    priority: Priority.HIGH,
    topics: [
      { id: "bio-zoo-h-1", name: "Parasitoses (Teníase, Cisticercose, Esquistossomose)", completed: false },
      { id: "bio-zoo-h-2", name: "Artrópodes", completed: false },
    ]
  },
  {
    subject: Subject.BIOLOGY,
    categoryName: "Zoologia e Embriologia",
    priority: Priority.MEDIUM,
    topics: [
      { id: "bio-zoo-m-1", name: "Embriologia e Células Tronco", completed: false },
      { id: "bio-zoo-m-2", name: "Introdução Animalia e Cordados", completed: false },
      { id: "bio-zoo-m-3", name: "Mamíferos", completed: false },
      { id: "bio-zoo-m-4", name: "Anexos Embrionários", completed: false },
    ]
  },
  {
    subject: Subject.BIOLOGY,
    categoryName: "Zoologia e Embriologia",
    priority: Priority.LOW,
    topics: [
      { id: "bio-zoo-l-1", name: "Invertebrados (Poríferos a Moluscos)", completed: false },
      { id: "bio-zoo-l-2", name: "Nematelmintos e Equinodermos", completed: false },
      { id: "bio-zoo-l-3", name: "Vertebrados (Peixes a Aves)", completed: false },
      { id: "bio-zoo-l-4", name: "Desenvolvimento embrionário (Fases)", completed: false },
    ]
  },

  // --- Fisiologia Humana e Histologia ---
  {
    subject: Subject.BIOLOGY,
    categoryName: "Fisiologia Humana e Histologia",
    priority: Priority.HIGH,
    topics: [
      { id: "bio-fis-h-1", name: "Sistema Circulatório", completed: false },
      { id: "bio-fis-h-2", name: "Sistema Digestório", completed: false },
      { id: "bio-fis-h-3", name: "Sistema Respiratório", completed: false },
      { id: "bio-fis-h-4", name: "Sistema Imune (Inato e Adaptativo)", completed: false },
      { id: "bio-fis-h-5", name: "Sistema Nervoso", completed: false },
      { id: "bio-fis-h-6", name: "Sistema Endócrino", completed: false },
    ]
  },
  {
    subject: Subject.BIOLOGY,
    categoryName: "Fisiologia Humana e Histologia",
    priority: Priority.MEDIUM,
    topics: [
      { id: "bio-fis-m-1", name: "Sistema Excretor e Urinário", completed: false },
      { id: "bio-fis-m-2", name: "Formas de Imunização", completed: false },
      { id: "bio-fis-m-3", name: "Sistemas Reprodutores e Ciclo Menstrual", completed: false },
      { id: "bio-fis-m-4", name: "Tecido Epitelial e Muscular", completed: false },
      { id: "bio-fis-m-5", name: "Tecido Hematopoiético", completed: false },
    ]
  },
  {
    subject: Subject.BIOLOGY,
    categoryName: "Fisiologia Humana e Histologia",
    priority: Priority.LOW,
    topics: [
      { id: "bio-fis-l-1", name: "Tecido Conjuntivo (Ósseo, Adiposo, Cartilaginoso)", completed: false },
      { id: "bio-fis-l-2", name: "Elementos do Sangue (Plaquetas, Leucócitos)", completed: false },
      { id: "bio-fis-l-3", name: "Visão Geral do Tecido Nervoso", completed: false },
    ]
  },
];

export const SOCIOLOGY_SYLLABUS = [
  // --- Introdução à Sociologia ---
  {
    subject: Subject.SOCIOLOGY,
    categoryName: "Introdução à Sociologia",
    priority: Priority.HIGH,
    topics: [
      { id: "soc-intro-h-1", name: "O que é a Sociologia?", completed: false },
      { id: "soc-intro-h-2", name: "Para que serve a Sociologia?", completed: false },
    ]
  },
  {
    subject: Subject.SOCIOLOGY,
    categoryName: "Introdução à Sociologia",
    priority: Priority.MEDIUM,
    topics: [
      { id: "soc-intro-m-1", name: "O Nascimento da Sociologia", completed: false },
    ]
  },

  // --- Sociologia Clássica ---
  {
    subject: Subject.SOCIOLOGY,
    categoryName: "Sociologia Clássica",
    priority: Priority.HIGH,
    topics: [
      { id: "soc-clas-h-1", name: "Funcionalismo de Durkheim e Fato Social", completed: false },
      { id: "soc-clas-h-2", name: "Durkheim: Suicídio", completed: false },
      { id: "soc-clas-h-3", name: "Karl Marx e Materialismo Histórico", completed: false },
      { id: "soc-clas-h-4", name: "Marxismo: Ideologia, Alienação e Fetichismo", completed: false },
      { id: "soc-clas-h-5", name: "Sociologia Compreensiva de Max Weber", completed: false },
      { id: "soc-clas-h-6", name: "Max Weber: Burocracia e Espírito do Capitalismo", completed: false },
    ]
  },
  {
    subject: Subject.SOCIOLOGY,
    categoryName: "Sociologia Clássica",
    priority: Priority.MEDIUM,
    topics: [
      { id: "soc-clas-m-1", name: "Positivismo e Auguste Comte", completed: false },
      { id: "soc-clas-m-2", name: "Durkheim: Modernidade e Trabalho", completed: false },
      { id: "soc-clas-m-3", name: "Socialismo e Crítica ao Capitalismo", completed: false },
      { id: "soc-clas-m-4", name: "Max Weber: Teoria da Modernidade e Estado", completed: false },
    ]
  },

  // --- Sociologia Contemporânea ---
  {
    subject: Subject.SOCIOLOGY,
    categoryName: "Sociologia Contemporânea",
    priority: Priority.HIGH,
    topics: [
      { id: "soc-cont-h-1", name: "Indústria Cultural", completed: false },
      { id: "soc-cont-h-2", name: "Pierre Bourdieu: Habitus e Capitais", completed: false },
      { id: "soc-cont-h-3", name: "Bourdieu: Dominação Masculina e Violência Simbólica", completed: false },
      { id: "soc-cont-h-4", name: "Michel Foucault: Vigiar e Punir", completed: false },
      { id: "soc-cont-h-5", name: "Zygmunt Bauman e a Pós-modernidade", completed: false },
    ]
  },
  {
    subject: Subject.SOCIOLOGY,
    categoryName: "Sociologia Contemporânea",
    priority: Priority.MEDIUM,
    topics: [
      { id: "soc-cont-m-1", name: "Escola de Frankfurt", completed: false },
      { id: "soc-cont-m-2", name: "Norbert Elias e o Processo Civilizador", completed: false },
      { id: "soc-cont-m-3", name: "Bourdieu: Conceito de Campo e Educação", completed: false },
      { id: "soc-cont-m-4", name: "Michel Foucault: Corpo, Poder e Sexualidade", completed: false },
    ]
  },
  {
    subject: Subject.SOCIOLOGY,
    categoryName: "Sociologia Contemporânea",
    priority: Priority.LOW,
    topics: [
      { id: "soc-cont-l-1", name: "Dialética do Esclarecimento", completed: false },
      { id: "soc-cont-l-2", name: "Norbert Elias: A Sociedade de Corte", completed: false },
      { id: "soc-cont-l-3", name: "Pensamento de Jürgen Habermas", completed: false },
    ]
  },
];

export const PHILOSOPHY_SYLLABUS = [
  // --- Introdução à Filosofia ---
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Introdução à Filosofia",
    priority: Priority.HIGH,
    topics: [
      { id: "fil-intro-h-1", name: "O que é filosofia?", completed: false },
      { id: "fil-intro-h-2", name: "Temas filosóficos mais cobrados no ENEM", completed: false },
      { id: "fil-intro-h-3", name: "Filosofia e redação", completed: false },
    ]
  },

  // --- Período Antigo: Pré-Socráticos e Sócrates ---
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Período Antigo: Pré-Socráticos e Sócrates",
    priority: Priority.HIGH,
    topics: [
      { id: "fil-ant1-h-1", name: "Introdução à Filosofia Antiga", completed: false },
      { id: "fil-ant1-h-2", name: "Nascimento da Filosofia e Mitos", completed: false },
      { id: "fil-ant1-h-3", name: "Sofistas: Definição e Teorias", completed: false },
      { id: "fil-ant1-h-4", name: "Sócrates e os Sofistas", completed: false },
      { id: "fil-ant1-h-5", name: "Sócrates: Dialética e Crítica", completed: false },
      { id: "fil-ant1-h-6", name: "Apologia de Sócrates", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Período Antigo: Pré-Socráticos e Sócrates",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fil-ant1-m-1", name: "Períodos e áreas da Filosofia", completed: false },
      { id: "fil-ant1-m-2", name: "Pré-socráticos: Definição", completed: false },
      { id: "fil-ant1-m-3", name: "Heráclito e Parmênides", completed: false },
      { id: "fil-ant1-m-4", name: "Sócrates: Biografia", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Período Antigo: Pré-Socráticos e Sócrates",
    priority: Priority.LOW,
    topics: [
      { id: "fil-ant1-l-1", name: "Tales, Anaximandro e Anaxímenes", completed: false },
      { id: "fil-ant1-l-2", name: "Leucipo e Demócrito", completed: false },
    ]
  },

  // --- Período Antigo: Platão e Aristóteles ---
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Período Antigo: Platão e Aristóteles",
    priority: Priority.HIGH,
    topics: [
      { id: "fil-ant2-h-1", name: "Platão: Teoria das Ideias e Mito da Caverna", completed: false },
      { id: "fil-ant2-h-2", name: "Platão: Teoria Política", completed: false },
      { id: "fil-ant2-h-3", name: "Aristóteles: Teoria Ética e Felicidade", completed: false },
      { id: "fil-ant2-h-4", name: "Aristóteles: Teoria Política", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Período Antigo: Platão e Aristóteles",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fil-ant2-m-1", name: "Platão: Biografia, Diálogo e Dialética", completed: false },
      { id: "fil-ant2-m-2", name: "Aristóteles: Biografia e Quatro Causas", completed: false },
      { id: "fil-ant2-m-3", name: "Aristóteles e a Escravidão", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Período Antigo: Platão e Aristóteles",
    priority: Priority.LOW,
    topics: [
      { id: "fil-ant2-l-1", name: "Lógica Aristotélica e Metafísica", completed: false },
    ]
  },

  // --- Escolas Helenísticas ---
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Escolas Helenísticas",
    priority: Priority.HIGH,
    topics: [
      { id: "fil-hel-h-1", name: "Estoicismo (Zenão de Cítio)", completed: false },
      { id: "fil-hel-h-2", name: "Epicurismo (Epicuro)", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Escolas Helenísticas",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fil-hel-m-1", name: "Ceticismo (Pirro de Élis)", completed: false },
      { id: "fil-hel-m-2", name: "Cinismo (Antístenes/Diógenes)", completed: false },
    ]
  },

  // --- Período Medieval ---
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Período Medieval",
    priority: Priority.HIGH,
    topics: [
      { id: "fil-med-h-1", name: "Santo Agostinho: O problema do Mal, Fé e Razão", completed: false },
      { id: "fil-med-h-2", name: "Tomás de Aquino: As cinco vias", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Período Medieval",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fil-med-m-1", name: "Patrística x Escolástica", completed: false },
      { id: "fil-med-m-2", name: "Santo Agostinho: Teoria da Iluminação", completed: false },
      { id: "fil-med-m-3", name: "Tomás de Aquino: Verdade e Escolástica", completed: false },
      { id: "fil-med-m-4", name: "Guilherme de Ockham e Anselmo de Cantuária", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Período Medieval",
    priority: Priority.LOW,
    topics: [
      { id: "fil-med-l-1", name: "Duns Escoto e Avicena", completed: false },
      { id: "fil-med-l-2", name: "Agostinho: Confissões e Política", completed: false },
    ]
  },

  // --- Renascimento e Maquiavel ---
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Renascimento e Política",
    priority: Priority.HIGH,
    topics: [
      { id: "fil-ren-h-1", name: "Humanismo Renascentista", completed: false },
      { id: "fil-ren-h-2", name: "Maquiavel: O Príncipe e Pensamento Político", completed: false },
      { id: "fil-ren-h-3", name: "Maquiavel: Os fins justificam os meios?", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Renascimento e Política",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fil-ren-m-1", name: "Do Mundo fechado ao Universo Infinito", completed: false },
      { id: "fil-ren-m-2", name: "Erasmo de Roterdã", completed: false },
    ]
  },

  // --- Filosofia da Ciência ---
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Filosofia da Ciência",
    priority: Priority.HIGH,
    topics: [
      { id: "fil-sci-h-1", name: "Introdução à Filosofia da Ciência", completed: false },
      { id: "fil-sci-h-2", name: "Francis Bacon", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Filosofia da Ciência",
    priority: Priority.LOW,
    topics: [
      { id: "fil-sci-l-1", name: "Nicolau Copérnico e Isaac Newton", completed: false },
    ]
  },

  // --- Período Moderno: Racionalismo e Empirismo ---
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Racionalismo e Empirismo",
    priority: Priority.HIGH,
    topics: [
      { id: "fil-mod1-h-1", name: "Descartes: Método, Cogito e Racionalismo", completed: false },
      { id: "fil-mod1-h-2", name: "Empirismo: Locke, Hobbes e Hume", completed: false },
      { id: "fil-mod1-h-3", name: "Ceticismo Empirista", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Racionalismo e Empirismo",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fil-mod1-m-1", name: "Descartes: Meditações", completed: false },
      { id: "fil-mod1-m-2", name: "Baruch Espinoza", completed: false },
      { id: "fil-mod1-m-3", name: "Edmund Burke: Conservadorismo", completed: false },
      { id: "fil-mod1-m-4", name: "Dogmatismo Empirista", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Racionalismo e Empirismo",
    priority: Priority.LOW,
    topics: [
      { id: "fil-mod1-l-1", name: "George Berkeley", completed: false },
    ]
  },

  // --- Período Moderno: Iluminismo e Kant ---
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Iluminismo e Kant",
    priority: Priority.HIGH,
    topics: [
      { id: "fil-mod2-h-1", name: "Iluminismo: Voltaire, Montesquieu, Rousseau, Smith", completed: false },
      { id: "fil-mod2-h-2", name: "Kant: Teoria do Conhecimento e Ética", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Iluminismo e Kant",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fil-mod2-m-1", name: "Despotismo Esclarecido", completed: false },
    ]
  },

  // --- Idealismo Alemão ---
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Idealismo Alemão",
    priority: Priority.HIGH,
    topics: [
      { id: "fil-ide-h-1", name: "Hegel", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Idealismo Alemão",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fil-ide-m-1", name: "Schopenhauer e Idealismo Geral", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Idealismo Alemão",
    priority: Priority.LOW,
    topics: [
      { id: "fil-ide-l-1", name: "Fichte e Schelling", completed: false },
    ]
  },

  // --- Período Contemporâneo I ---
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Filosofia Contemporânea I",
    priority: Priority.HIGH,
    topics: [
      { id: "fil-cont1-h-1", name: "Escola de Frankfurt: Teoria Crítica e Indústria Cultural", completed: false },
      { id: "fil-cont1-h-2", name: "Hannah Arendt: Banalidade do Mal", completed: false },
      { id: "fil-cont1-h-3", name: "Mestres da Suspeita: Nietzsche, Freud, Marx", completed: false },
      { id: "fil-cont1-h-4", name: "Marx: Ideologia e Materialismo Histórico", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Filosofia Contemporânea I",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fil-cont1-m-1", name: "Heidegger e Wittgenstein", completed: false },
      { id: "fil-cont1-m-2", name: "Dialética do Esclarecimento", completed: false },
      { id: "fil-cont1-m-3", name: "Habermas, Rorty e Hans Jonas", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Filosofia Contemporânea I",
    priority: Priority.LOW,
    topics: [
      { id: "fil-cont1-l-1", name: "Nozick: Anarquia, Estado e Utopia", completed: false },
    ]
  },

  // --- Período Contemporâneo II ---
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Filosofia Contemporânea II",
    priority: Priority.HIGH,
    topics: [
      { id: "fil-cont2-h-1", name: "Existencialismo: Sartre e Camus", completed: false },
      { id: "fil-cont2-h-2", name: "Pós-estruturalismo e Michel Foucault", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Filosofia Contemporânea II",
    priority: Priority.MEDIUM,
    topics: [
      { id: "fil-cont2-m-1", name: "Fenomenologia, Kierkegaard e Merleau-Ponty", completed: false },
      { id: "fil-cont2-m-2", name: "Estruturalismo, Derrida, Lyotard e Deleuze", completed: false },
    ]
  },
  {
    subject: Subject.PHILOSOPHY,
    categoryName: "Filosofia Contemporânea II",
    priority: Priority.LOW,
    topics: [
      { id: "fil-cont2-l-1", name: "Edmund Husserl", completed: false },
    ]
  },
];

export const WRITING_SYLLABUS = [
  // --- Estrutura e Parágrafos ---
  {
    subject: Subject.WRITING,
    categoryName: "Estrutura e Parágrafos",
    priority: Priority.HIGH,
    topics: [
      { id: "red-est-h-1", name: "Texto dissertativo-argumentativo", completed: false },
      { id: "red-est-h-2", name: "Estrutura padrão: o que precisa ter?", completed: false },
      { id: "red-est-h-3", name: "Como construir um parágrafo-padrão", completed: false },
    ]
  },
  {
    subject: Subject.WRITING,
    categoryName: "Estrutura e Parágrafos",
    priority: Priority.MEDIUM,
    topics: [
      { id: "red-est-m-1", name: "Características do texto dissertativo", completed: false },
      { id: "red-est-m-2", name: "Estrutura do parágrafo", completed: false },
    ]
  },

  // --- Introdução e Desenvolvimento ---
  {
    subject: Subject.WRITING,
    categoryName: "Introdução e Desenvolvimento",
    priority: Priority.HIGH,
    topics: [
      { id: "red-id-h-1", name: "Tese na redação do Enem", completed: false },
      { id: "red-id-h-2", name: "Como fazer um bom desenvolvimento", completed: false },
      { id: "red-id-h-3", name: "Como organizar as ideias no desenvolvimento", completed: false },
    ]
  },
  {
    subject: Subject.WRITING,
    categoryName: "Introdução e Desenvolvimento",
    priority: Priority.MEDIUM,
    topics: [
      { id: "red-id-m-1", name: "Passos para introdução perfeita", completed: false },
      { id: "red-id-m-2", name: "Como fechar os parágrafos de desenvolvimento", completed: false },
    ]
  },

  // --- Argumentação ---
  {
    subject: Subject.WRITING,
    categoryName: "Argumentação",
    priority: Priority.HIGH,
    topics: [
      { id: "red-arg-h-1", name: "Escolher um argumento coerente", completed: false },
    ]
  },
  {
    subject: Subject.WRITING,
    categoryName: "Argumentação",
    priority: Priority.MEDIUM,
    topics: [
      { id: "red-arg-m-1", name: "Estratégias de argumentação e exemplos", completed: false },
    ]
  },
  {
    subject: Subject.WRITING,
    categoryName: "Argumentação",
    priority: Priority.LOW,
    topics: [
      { id: "red-arg-l-1", name: "Falácias na argumentação", completed: false },
    ]
  },

  // --- Conclusão e Intervenção (Competência 5) ---
  {
    subject: Subject.WRITING,
    categoryName: "Conclusão e Intervenção",
    priority: Priority.HIGH,
    topics: [
      { id: "red-conc-h-1", name: "Conclusão da redação", completed: false },
      { id: "red-conc-h-2", name: "Proposta de intervenção ENEM", completed: false },
      { id: "red-conc-h-3", name: "Competência 5", completed: false },
    ]
  },
  {
    subject: Subject.WRITING,
    categoryName: "Conclusão e Intervenção",
    priority: Priority.MEDIUM,
    topics: [
      { id: "red-conc-m-1", name: "Tipos de conclusão", completed: false },
      { id: "red-conc-m-2", name: "Por que existe a competência 5?", completed: false },
    ]
  },

  // --- Competências 1, 2, 3 e 4 ---
  {
    subject: Subject.WRITING,
    categoryName: "Competências de Avaliação",
    priority: Priority.HIGH,
    topics: [
      { id: "red-comp-h-1", name: "Competência 1: Norma culta e Desvios", completed: false },
      { id: "red-comp-h-2", name: "Competência 2: Tema e Abordagem completa", completed: false },
      { id: "red-comp-h-3", name: "Competência 3: Projeto de texto e Tese", completed: false },
      { id: "red-comp-h-4", name: "Competência 4: Coesão e Conectivos", completed: false },
      { id: "red-comp-h-5", name: "Falhas sintáticas graves", completed: false },
    ]
  },
  {
    subject: Subject.WRITING,
    categoryName: "Competências de Avaliação",
    priority: Priority.MEDIUM,
    topics: [
      { id: "red-comp-m-1", name: "Como é feita a correção do ENEM?", completed: false },
      { id: "red-comp-m-2", name: "Repertório sociocultural (Competência 2)", completed: false },
      { id: "red-comp-m-3", name: "Planejamento estratégico (Competência 3)", completed: false },
      { id: "red-comp-m-4", name: "Coesão textual: tipos e características", completed: false },
    ]
  },

  // --- Repertório e Textos Motivadores ---
  {
    subject: Subject.WRITING,
    categoryName: "Repertório e Textos Motivadores",
    priority: Priority.HIGH,
    topics: [
      { id: "red-rep-h-1", name: "Interpretar e utilizar textos motivadores", completed: false },
    ]
  },
  {
    subject: Subject.WRITING,
    categoryName: "Repertório e Textos Motivadores",
    priority: Priority.MEDIUM,
    topics: [
      { id: "red-rep-m-1", name: "Como ampliar o repertório sociocultural", completed: false },
    ]
  },

  // --- Gramática e Tipologia ---
  {
    subject: Subject.WRITING,
    categoryName: "Gramática e Tipologia",
    priority: Priority.LOW,
    topics: [
      { id: "red-gram-l-1", name: "Gramática para redação (erros comuns)", completed: false },
      { id: "red-gram-l-2", name: "Gênero textual x Tipologia textual", completed: false },
    ]
  },

  // --- Outros Gêneros Textuais ---
  {
    subject: Subject.WRITING,
    categoryName: "Outros Gêneros Textuais",
    priority: Priority.LOW,
    topics: [
      { id: "red-out-l-1", name: "Artigo de opinião", completed: false },
      { id: "red-out-l-2", name: "Carta Argumentativa", completed: false },
      { id: "red-out-l-3", name: "Crônica", completed: false },
      { id: "red-out-l-4", name: "Editorial e Notícia", completed: false },
    ]
  },
];

export const FULL_SYLLABUS = [
  ...MATH_SYLLABUS, 
  ...PORTUGUESE_SYLLABUS, 
  ...PHYSICS_SYLLABUS, 
  ...CHEMISTRY_SYLLABUS, 
  ...HISTORY_SYLLABUS, 
  ...GEOGRAPHY_SYLLABUS, 
  ...BIOLOGY_SYLLABUS, 
  ...SOCIOLOGY_SYLLABUS, 
  ...PHILOSOPHY_SYLLABUS, 
  ...WRITING_SYLLABUS
];

export const PRIORITY_COLORS = {
  [Priority.HIGH]: 'bg-red-100 text-red-800 border-red-200',
  [Priority.MEDIUM]: 'bg-yellow-100 text-yellow-800 border-yellow-200',
  [Priority.LOW]: 'bg-green-100 text-green-800 border-green-200',
};

export const PRIORITY_LABELS = {
  [Priority.HIGH]: 'Alta Prioridade',
  [Priority.MEDIUM]: 'Média Prioridade',
  [Priority.LOW]: 'Baixa Prioridade',
};

export const SUBJECT_LABELS = {
  [Subject.MATH]: 'Matemática',
  [Subject.PORTUGUESE]: 'Português',
  [Subject.PHYSICS]: 'Física',
  [Subject.CHEMISTRY]: 'Química',
  [Subject.HISTORY]: 'História',
  [Subject.GEOGRAPHY]: 'Geografia',
  [Subject.BIOLOGY]: 'Biologia',
  [Subject.SOCIOLOGY]: 'Sociologia',
  [Subject.PHILOSOPHY]: 'Filosofia',
  [Subject.WRITING]: 'Redação',
};

export const SUBJECT_COLORS = {
  [Subject.MATH]: 'bg-blue-100 text-blue-800',
  [Subject.PORTUGUESE]: 'bg-purple-100 text-purple-800',
  [Subject.PHYSICS]: 'bg-emerald-100 text-emerald-800',
  [Subject.CHEMISTRY]: 'bg-orange-100 text-orange-800',
  [Subject.HISTORY]: 'bg-amber-100 text-amber-800',
  [Subject.GEOGRAPHY]: 'bg-teal-100 text-teal-800',
  [Subject.BIOLOGY]: 'bg-lime-100 text-lime-800',
  [Subject.SOCIOLOGY]: 'bg-rose-100 text-rose-800',
  [Subject.PHILOSOPHY]: 'bg-pink-100 text-pink-800',
  [Subject.WRITING]: 'bg-cyan-100 text-cyan-800',
};